import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { hotArticles } from "@/mocks/articles";
import { categories } from "@/mocks/site";

export default function RankingSection() {
  const ranked = [...hotArticles].sort((a, b) => b.views - a.views);

  return (
    <section id="ranking" className="mx-auto max-w-content scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        kicker="HOT LIST"
        title="爆料热榜"
        desc="按近 7 日阅读量排序，榜单每小时更新一次，长期跟踪的事件会持续留榜。"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="overflow-hidden rounded-lg border border-background-200">
            <div className="hidden grid-cols-12 gap-4 bg-background-100 px-5 py-3 text-[11px] font-medium tracking-wider text-foreground-500 md:grid">
              <span className="col-span-1">排名</span>
              <span className="col-span-6">事件</span>
              <span className="col-span-2">分类</span>
              <span className="col-span-2">证据链</span>
              <span className="col-span-1 text-right">阅读</span>
            </div>
            {ranked.map((item, index) => (
              <Link
                key={item.id}
                to={`/article/${item.id}`}
                className="grid cursor-pointer grid-cols-12 items-center gap-3 border-t border-background-200 px-4 py-4 transition-colors hover:bg-background-100 md:gap-4 md:px-5"
              >
                <span className="col-span-2 md:col-span-1">
                  <span
                    className={`flex h-7 w-7 items-center justify-center rounded-md font-heading text-xs font-bold ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                </span>
                <span className="col-span-10 md:col-span-6">
                  <span className="block font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                    {item.title}
                  </span>
                  <span className="mt-1 block text-[11px] text-foreground-500 md:hidden">
                    {item.category} · {item.evidence.length} 条证据链
                  </span>
                </span>
                <span className="col-span-2 hidden text-xs text-foreground-600 md:block">
                  {item.category}
                </span>
                <span className="col-span-2 hidden items-center gap-1 text-xs text-foreground-600 md:flex">
                  <span className="flex h-3.5 w-3.5 items-center justify-center text-secondary-500">
                    <i className="ri-links-line"></i>
                  </span>
                  {item.evidence.length} 条
                </span>
                <span className="col-span-1 hidden text-right text-xs text-foreground-500 md:block">
                  {(item.views / 1000).toFixed(0)}k
                </span>
              </Link>
            ))}
          </div>
        </div>

        <aside className="flex flex-col gap-5 lg:col-span-4">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="font-heading text-base font-bold text-foreground-950">本周高频关键词</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {[
                "换角风波",
                "补充协议",
                "剪辑逻辑",
                "账号归属",
                "退票责任",
                "道德条款",
                "路透外泄",
                "行程重叠",
                "分账比例",
                "同框传闻",
              ].map((word) => (
                <span
                  key={word}
                  className="rounded-md border border-background-300 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="font-heading text-base font-bold text-foreground-950">按分类浏览</h3>
            <ul className="mt-4 space-y-2">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/?cat=${item.slug}#latest`}
                    className="flex cursor-pointer items-center justify-between gap-2 rounded-md px-3 py-2.5 transition-colors hover:bg-background-100"
                  >
                    <span className="flex items-center gap-2 text-sm text-foreground-800">
                      <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                        <i className={item.icon}></i>
                      </span>
                      {item.name}
                    </span>
                    <span className="text-xs text-foreground-500">{item.count} 篇</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}